import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IConfirmStringDialogComponentInParams {
  title: string;
  message: string;
  stringToConfirm: string;
  confirmButton: string;
  cancelButton: string;
  confirmPlaceholder?: string;
}

@Component({
    templateUrl: './confirm-string-dialog.component.html',
    standalone: false
})
export class ConfirmStringDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmStringDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmStringDialogComponentInParams) {
  }

  public confirmString = '';

  get canConfirm(): boolean {
    return this.confirmString === this.data.stringToConfirm;
  }

  onConfirmClicked() {
    this.dialogRef.close(true);
  }

  onCancelClicked() {
    this.dialogRef.close(false)
  }
}
